import { Icon } from 'leaflet';
import carPin from './car-pin.svg';
import startPin from './start-pin.svg';
import finishPin from './finish-pin.svg';
import intermediatePin from './intermediate-pin.svg';
import passengerPin from './passenger-pin.svg';

export const carIcon = new Icon({
  iconUrl: carPin,
  iconSize: [68, 66],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const startPointIcon = new Icon({
  iconUrl: startPin,
  iconSize: [30, 42],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const finishPointIcon = new Icon({
  iconUrl: finishPin,
  iconSize: [30, 42],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const intermediatePointIcon = new Icon({
  iconUrl: intermediatePin,
  iconSize: [30, 42],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const passengerPointIcon = new Icon({
  iconUrl: passengerPin,
  iconSize: [30, 42],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});
